module.exports = __webpack_public_path__ + "img/logo07.78e990e.jpg";